module.exports = __webpack_public_path__ + "static/media/cryptoswitch.dba6399d.png";